module.exports = __webpack_public_path__ + "static/img/3areaA_20.0897a22.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/特日/3areaA_20.png
// module id = 984
// module chunks = 1